"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractTimeExpressionParser_1 = require("../../../common/parsers/AbstractTimeExpressionParser");

var FRTimeExpressionParser = /*#__PURE__*/function (_AbstractTimeExpressi) {
  _inherits(FRTimeExpressionParser, _AbstractTimeExpressi);

  var _super = _createSuper(FRTimeExpressionParser);

  function FRTimeExpressionParser() {
    _classCallCheck(this, FRTimeExpressionParser);

    return _super.apply(this, arguments);
  }

  _createClass(FRTimeExpressionParser, [{
    key: "primaryPrefix",
    value: function primaryPrefix() {
      return "(?:(?:[àa])\\s*)?";
    }
  }, {
    key: "followingPhase",
    value: function followingPhase() {
      return "\\s*(?:\\-|\\–|\\~|\\〜|[àa]|\\?)\\s*";
    }
  }, {
    key: "extractPrimaryTimeComponents",
    value: function extractPrimaryTimeComponents(context, match) {
      if (match[0].match(/^\s*\d{4}\s*$/)) {
        return null;
      }

      return _get(_getPrototypeOf(FRTimeExpressionParser.prototype), "extractPrimaryTimeComponents", this).call(this, context, match);
    }
  }]);

  return FRTimeExpressionParser;
}(AbstractTimeExpressionParser_1.AbstractTimeExpressionParser);

exports.default = FRTimeExpressionParser;